import { useMemo } from 'react';
import { Hero } from './components/Hero';
import { RecentDesigns } from './components/RecentDesigns';
import { BrandKit } from './components/BrandKit';
import { TemplateSection } from './components/TemplateSection';
import { useGetTemplatesQuery, Template } from '../../features/templates/templatesApi';

// Main Content
const HomeContent = () => {
  const { data: templatesData, isLoading } = useGetTemplatesQuery({ limit: 50 });

  const categoryGroups = useMemo(() => {
    const templates = templatesData?.data || [];

    // Group by category field specifically
    const groups: Record<string, Template[]> = {};
    templates.forEach(template => {
      // Use category field (e.g., Healthcare, Retail, etc.)
      const cat = template.category || "Other";
      if (!groups[cat]) {
        groups[cat] = [];
      }
      groups[cat].push(template);
    });

    return groups;
  }, [templatesData]);

  return (
    <div className="content-stretch flex flex-col gap-[32px] items-start relative shrink-0 w-full">
      <Hero />
      <div className="content-stretch flex flex-col gap-[48px] items-start relative shrink-0 w-full pb-10">
        <RecentDesigns />
        <BrandKit />

        {Object.entries(categoryGroups).map(([category, templates]) => (
          <TemplateSection
            key={category}
            title={category}
            templates={templates}
            isLoading={isLoading}
          />
        ))}

        {!isLoading && Object.keys(categoryGroups).length === 0 && (
          <div className="w-full py-12 flex flex-col items-center justify-center text-gray-500 bg-gray-50 rounded-lg border border-dashed border-gray-200">
            <p className="font-medium text-lg">No templates found</p>
            <p className="text-sm">Try checking back later or browse other categories.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default function HomeDashboard() {
  return (
    <HomeContent />
  );
}

